export interface GeneralInformation {
    locationName: string;
    locationAddress: string;
    numStations: number;
}

export type DayKey =
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";

export const DayKeys = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
] as const;

export type WorkingHoursValue = "non-stop" | "closed" | { open: string; close: string };

export type WorkingHoursMap = Record<DayKey, WorkingHoursValue>;
